const taxSavingsRestrictedStates = [
  'AK',
  'CA',
  'DC',
  'HI',
  'MT',
  'NH',
  'OH',
  'OK',
  'OR',
  'VA'
];

export default taxSavingsRestrictedStates;
